export default __webpack_public_path__ + "static/media/116.be015c22.jpg";